export default "__VITE_ASSET__ykb1zIozoJBMq4UvQnlhcQ__"